import { Injectable } from '@angular/core';

@Injectable()
export class FiledLibMapperService {
	constructor() {}

	public convertToDropdownData<T = any>(data: T[], valueKey: string, displayNameKey: string): any[] {
		return data.map(item => {
			return {
				name: (item as any)[displayNameKey],
				id: (item as any)[valueKey],
				data: item
			};
		});
	}
}
